import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./../reducers";
import logger from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["authorizationReducer"],
};

var middlewares = (middlewares = applyMiddleware(thunk));

const pReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(pReducer, middlewares);

const persistor = persistStore(store);

export { persistor, store };
